/* eslint-disable no-console */
import PasswordResetForm from './PasswordResetForm';

export const Empty = {
  component: PasswordResetForm,
  props: {
    formId: 'PasswordResetFormExample',
    onSubmit(values) {
      
    },
  },
  group: 'forms',
};
